<section class="drilldown-page">
  <header class="drilldown-heading">
    <div>
      <p class="eyebrow">MASTERS</p>
      <h1>Uploaded Masters</h1>
      <p class="range">{{ rangeLabel() }}</p>
    </div>
    <a class="back-button" routerLink="/app" aria-label="Back to dashboard" title="Back to dashboard"><i class="bi bi-arrow-left" aria-hidden="true"></i></a>
  </header>

  <section class="drilldown-card" [attr.aria-busy]="loading()">
    <div class="table-toolbar">
      <div><h2>Uploaded files</h2><p>Open a Master to view its details.</p></div>
      <div class="table-controls">
        <span class="count" *ngIf="page() as result">{{ result.totalElements | number }} files</span>
        <label>Rows per page <select [value]="pageSize()" (change)="changePageSize($event)" [disabled]="loading()">
          <option value="25">25</option><option value="50">50</option><option value="100">100</option>
        </select></label>
      </div>
    </div>
    <p *ngIf="loading()" class="state" role="status">Loading Masters…</p>
    <p *ngIf="error()" class="state error" role="alert">Could not load uploaded Masters. Please try again.</p>
    <ng-container *ngIf="page() as result">
      <div class="table-scroll" *ngIf="result.content.length; else emptyPage">
        <table class="uploaded-table">
          <colgroup>
            <col class="col-id"><col class="col-reference"><col class="col-ecu"><col class="col-producer">
            <col class="col-vehicle"><col class="col-date"><col class="col-actions">
          </colgroup>
          <thead>
            <tr><th>ID</th><th>WinOLS Reference</th><th>ECU Build</th><th>ECU Producer</th><th>Vehicle Producer</th><th>Date Uploaded</th><th>Actions</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of result.content" (click)="openDetails(row)" (keydown.enter)="openDetails(row)" (keydown.space)="$event.preventDefault(); openDetails(row)" tabindex="0" [attr.aria-label]="'Open Master ' + row.id">
              <td [title]="row.id"><span class="file-link">{{ row.id }}</span></td>
              <td [title]="row.winOLSReference">{{ row.winOLSReference || '—' }}</td>
              <td [title]="row.ecuBuild">{{ row.ecuBuild || '—' }}</td>
              <td [title]="row.ecuProducer">{{ row.ecuProducer || '—' }}</td>
              <td [title]="row.vehicleProducer">{{ row.vehicleProducer || '—' }}</td>
              <td>{{ row.dateUploaded || '—' }}</td>
              <td><button type="button" class="details-button" (click)="$event.stopPropagation(); openDetails(row)" [attr.aria-label]="'View Master ' + row.id" title="View details"><i class="bi bi-eye"></i></button></td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #emptyPage><p class="state">No Masters were uploaded in this period.</p></ng-template>
      <nav class="pager" *ngIf="result.totalPages > 1" aria-label="Uploaded Masters pages">
        <button type="button" class="secondary-button" (click)="goToPage(pageNumber() - 1)" [disabled]="pageNumber() === 0">Previous</button>
        <span>Page {{ pageNumber() + 1 }} of {{ result.totalPages }}</span>
        <button type="button" class="secondary-button" (click)="goToPage(pageNumber() + 1)" [disabled]="result.last">Next</button>
      </nav>
    </ng-container>
  </section>
</section>
